export enum PropertyValueSource {
  Zillow = 'zillow',
  SaleContract = 'sale_contract',
  Redfin = 'redfin',
  Appraisal = 'appraisal',
  Other = 'other',
}
